// Small geometry helpers for the code-drawn art.
export { between, createRng, pick, round } from "../../RoyalMahal/art/rng";

const r2 = (n) => Math.round(n * 100) / 100;

/** Closed path for a ruffled ring: radius `r` with `bumps` scallops of depth `depth`. */
export const rufflePath = (r, bumps, depth, phase = 0) => {
  const steps = bumps * 6;
  const points = [];
  for (let i = 0; i < steps; i += 1) {
    const t = (i / steps) * Math.PI * 2;
    const rr = r + depth * Math.abs(Math.sin((t * bumps) / 2 + phase));
    points.push(`${r2(Math.cos(t) * rr)},${r2(Math.sin(t) * rr)}`);
  }
  return `M${points.join("L")}Z`;
};

/** A pointed leaf of length `len` lying along +x from the origin. */
export const leafPath = (len = 12, width = 0.36) => {
  const w = len * width;
  return `M0,0 C${r2(len * 0.25)},${r2(-w)} ${r2(len * 0.75)},${r2(-w)} ${len},0 C${r2(len * 0.75)},${r2(w)} ${r2(len * 0.25)},${r2(w)} 0,0Z`;
};

export { r2 };
